import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';

const HouseIcon = RESIDENTS_SVG_COMPONENTS.HOME_PAGE;

interface BreadcrumbNavigationProps {
  onHomePress: () => void;
  onBackPress: () => void;
}

export const BreadcrumbNavigation: React.FC<BreadcrumbNavigationProps> = ({
  onHomePress,
  onBackPress,
}) => (
  <View style={styles.container}>
    <TouchableOpacity style={styles.homeIconContainer} onPress={onHomePress}>
      <HouseIcon width={15} height={15} color={MARKETPLACE_COLORS.accentBlue} />
    </TouchableOpacity>
    <TouchableOpacity style={styles.breadcrumbLink} onPress={onBackPress}>
      <Text style={styles.breadcrumbEllipsis}>...</Text>
      <Text style={styles.breadcrumbText}>Previous page</Text>
    </TouchableOpacity>
  </View>
);

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  homeIconContainer: {
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: MARKETPLACE_COLORS.accentBlueBg,
    alignItems: 'center',
    justifyContent: 'center',
  },
  breadcrumbLink: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  breadcrumbEllipsis: {
    fontSize: 12,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.accentBlue,
    lineHeight: 18,
  },
  breadcrumbText: {
    fontSize: 12,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.accentBlue,
    lineHeight: 18,
  },
});

